var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboCloseCircleSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.33333C11.1267 2.33333 13.6667 4.87333 13.6667 8C13.6667 11.1267 11.1267 13.6667 8 13.6667C4.87333 13.6667 2.33333 11.1267 2.33333 8C2.33333 4.87333 4.87333 2.33333 8 2.33333ZM8 1C4.13333 1 1 4.13333 1 8C1 11.8667 4.13333 15 8 15C11.8667 15 15 11.8667 15 8C15 4.13333 11.8667 1 8 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0737 5H10.1337C10.047 5 9.96035 5.03333 9.90035 5.1L7.94035 7.06L5.98035 5.1C5.92035 5.04 5.83368 5 5.74701 5H4.80701C4.50701 5 4.36035 5.36 4.57368 5.56667L7.00701 8L4.57368 10.4333C4.36701 10.64 4.51368 11 4.80701 11H5.74701C5.83368 11 5.92035 10.9667 5.98035 10.9L7.94035 8.94L9.90035 10.9C9.96035 10.96 10.047 11 10.1337 11H11.0737C11.3737 11 11.5203 10.64 11.307 10.4333L8.87368 8L11.307 5.56667C11.5137 5.36 11.367 5 11.0737 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboCloseCircleSmall);
export default __webpack_public_path__ + "static/media/FBOCloseCircleSmall.f1881e6a3e50b283d26877b8393a8924.svg";
export { ForwardRef as ReactComponent };